import axios from 'axios';
import router from '../router/index';
import store from '../store/index';
import vuex from '../store/index';


(window as any).initMiniSentry({ dsn: 'https://sentry.cryptogold.exchange/ingest'})

const tkN = 'tk';

const abort = new AbortController();

export const authAbortSignal = abort.signal;

export const storage = {
  getToken() {
    return localStorage.getItem(tkN);
  },
  setToken(token: string) {
    localStorage.setItem(tkN, token)
  },
  removeToken() {
    localStorage.removeItem(tkN);
  },
  isLoggedIn() {
    return !!this.getToken();
  },
};

export const isLoggedIn = () => storage.isLoggedIn();
export const logOut = () => { storage.removeToken(); abort.abort(); };

function onFullfilled(response: any) {
  const authorization = response.data.token;
  if (authorization) {
    storage.setToken(authorization);
  }
  return response;
}

function onRejected(err: any) {
  try {
    if (!(err instanceof NoSentryUnAuthError)) {
      let payload: any = 'Failed to parse from JSON';
      try {
        payload = typeof err?.config?.data === 'string' ? JSON.parse(err.config.data) : 'Not a string payload';
      } catch (ex) {
        console.error(ex);
      }
      if (payload.password) {
        payload.password = '[reducted]';
      }
      if (payload.code) {
        payload.code = '[reducted]';
      }
      let clientEmail = null;
      if (err?.config?.url === '/auth/login') {
        clientEmail = payload.email;
      }
      const data = { payload, url: err?.config?.url, baseURL: err?.config?.baseURL, response: err?.response?.data };
      (window as any).msentry.error("Request error " + err?.message, { data: data, stack: err?.stack, clientEmail })
    }
  } catch (err) {
    console.error(err)
  }
  if (err.response && err.response.status === 500) {
    // {data:err.response.data, url:err.response.config.url, method:err.response.config.method}
    // vuex.commit('INTERNAL_ERROR', true)
  }

  if (err.response && err.response.status === 409) {
    console.log('Back-end maintenance...');
  }

  if (err instanceof NoSentryUnAuthError || err.response && err.response.status === 401) {
    store.dispatch('logout');
    // storage.removeToken();
    const currentRoutePath = router?.currentRoute?.value?.path;
    if (!currentRoutePath.includes('registration') && !currentRoutePath.includes('login') && !currentRoutePath.includes('reset-password')) {
      router.push('/login');
    }
    // router.push('/');
  }


  if (err.response && err.response.status === 402) {
    alert('402 error');
  }

  return Promise.reject(err.response);
}

function onRequestError(error: any) {
  return Promise.reject(error);
}

function getRndInteger(min: number, max: number) {
  return Math.floor(Math.random() * (max - min)) + min;
}

class NoSentryUnAuthError extends Error {

}

const privatePath = process.env.VUE_APP_API_PATH;

const configure = (axios: any) => {
  axios.defaults.baseURL = `${privatePath}`;
  // axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';

  axios.interceptors.request.use((config: any) => {
    if (storage.isLoggedIn()) {
      config.headers['Authorization'] = 'Bearer ' + storage.getToken();
    } else {
      if (config.url === '/balances' || config.url === '/users/profile' || config.url === '/users/referral/tree' || config.url === '/users/referral/stats') {
        throw new NoSentryUnAuthError("Unauthed");
      }
    }
    if (!config.data) {
      config.data = {};
    }
    config.data['project_id'] = +process.env.VUE_APP_PROJECT_ID!;
    return config;
  }, onRequestError);

  axios.interceptors.response.use(onFullfilled, onRejected);

  // axios.interceptors.response.use(function (response) {
  //   // Do something with response data
  //   return response;
  // }, function (error) {
  //   // Do something with response error
  //   console.log("aaaaaaaaaaaaaaaaaaaaaa",error.message);
  //   return Promise.reject(error);
  // });

  return axios;
};
export default configure(axios);